import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { CASE_STUDIES } from "@/data/experience";

export default function ExperienceSection() {
  return (
    <section data-testid="experience-section" className="border-b border-line bg-white">
      <div className="mx-auto max-w-7xl px-6 py-20 sm:py-28">
        <Reveal>
          <p className="mb-6 flex items-center gap-3 font-mono text-[11px] tracking-[0.3em] text-slate-500">
            <span className="h-px w-10 bg-slate-300" aria-hidden="true" />
            04 — REPRESENTATIVE EXPERIENCE
          </p>
        </Reveal>
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <Reveal delay={0.08}>
            <h2 className="max-w-2xl font-serif text-3xl leading-tight tracking-tight text-ink sm:text-4xl lg:text-5xl">
              Experience, stated specifically.
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="max-w-md leading-relaxed text-slate-600">
              Anonymized case studies from the prior professional experience of Improve
              Systems' principal — volumes, systems, methodology, and outcomes, with
              identifiers omitted to protect confidentiality.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 border-t border-line">
          {CASE_STUDIES.map((cs, i) => (
            <Reveal key={cs.slug} delay={i * 0.06}>
              <Link
                to={`/experience#${cs.slug}`}
                data-testid={`experience-card-${cs.slug}`}
                className="group grid gap-3 border-b border-line py-8 transition-colors duration-300 hover:bg-canvas sm:grid-cols-12 sm:items-baseline sm:gap-8"
              >
                <span className="font-mono text-[11px] text-slate-400 sm:col-span-1">
                  {cs.index}
                </span>
                <div className="sm:col-span-8">
                  <p className="font-mono text-[10px] tracking-[0.25em] text-slate-400">
                    {cs.tag}
                  </p>
                  <h3 className="mt-2 font-serif text-2xl leading-snug text-ink transition-colors duration-300 group-hover:text-accent-deep sm:text-3xl">
                    {cs.title}
                  </h3>
                  <p className="mt-3 max-w-2xl text-sm leading-relaxed text-slate-600">
                    {cs.summary}
                  </p>
                </div>
                <div className="flex sm:col-span-3 sm:justify-end">
                  <ArrowUpRight className="h-4 w-4 text-slate-400 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-ink" />
                </div>
              </Link>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <p className="mt-8 font-mono text-[10px] leading-relaxed tracking-[0.2em] text-slate-400">
            PRIOR PROFESSIONAL EXPERIENCE OF IMPROVE SYSTEMS' PRINCIPAL · IDENTIFIERS OMITTED
            TO PROTECT CONFIDENTIALITY
          </p>
        </Reveal>
      </div>
    </section>
  );
}
